module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-di-ap-98576d42.png";